import React from 'react';
import AuthorMappingStep from './AuthorMappingStep';

export default function CopyrightHolderStep({
  chunks,
  copyrightHolders,
  onUpdateChunks,
  fileUrl,
  numPages,
}) {
  return (
    <AuthorMappingStep
      chunks={chunks}
      copyrightHolders={copyrightHolders}
      onUpdateChunks={onUpdateChunks}
      fileUrl={fileUrl}
      numPages={numPages}
    />
  );
}